export default __webpack_public_path__ + "static/media/event_active.cf3d7c39.svg";